import { render, staticRenderFns } from "./AccountVerify.vue?vue&type=template&id=2fc637a0&scoped=true"
import script from "./AccountVerify.vue?vue&type=script&lang=js"
export * from "./AccountVerify.vue?vue&type=script&lang=js"
import style0 from "./AccountVerify.vue?vue&type=style&index=0&id=2fc637a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc637a0",
  null
  
)

export default component.exports